import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BASE_URL from '../../../../config/config';

export default function AddCategory() {  
  const [formData, setFormData] = useState({
    name: '',
    slug: '',
    description: ''
  });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState('');
  const [csrfToken, setCsrfToken] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // دریافت CSRF Token
    fetch(`${BASE_URL}/csrf-token`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => setCsrfToken(data.csrfToken))
      .catch(console.error);
  }, []);

  const generateSlug = (text) => {
    if (!text) return "";

    return text
      .replace(/[\s]+/g, "_")
      .replace(/[^\u0600-\u06FFa-zA-Z0-9_]/g, "")
      .replace(/_+/g, "_")
      .replace(/^_+|_+$/g, "");
  };

  const handleNameChange = (e) => {
    const name = e.target.value;
    setFormData(prev => ({
      ...prev,
      name,
      slug: generateSlug(name)
    }));
  };

  const handleSlugChange = (e) => {
    const slug = generateSlug(e.target.value);
    setFormData(prev => ({ ...prev, slug }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: null }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch(`${BASE_URL}/blog/categories`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          "CSRF-Token": csrfToken,
        },
        credentials: "include",
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        setErrors(data.errors || {});
        setMessage(data.message || 'خطا در ایجاد دسته‌بندی');
        return;
      }

      setMessage('دسته‌بندی با موفقیت ایجاد شد');
      setTimeout(() => navigate('/admin/blog/categories'), 1500);
    } catch (err) {
      setMessage('خطا در ارتباط با سرور');
    }
  };

  return (
    <div className="category-form-container">
      <h2>افزودن دسته‌بندی جدید</h2>
      
      {message && (
        <div className={`alert ${message.includes('موفق') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>نام دسته‌بندی</label>
          <input
            name="name"
            value={formData.name}
            onChange={handleNameChange}
            className={errors.name ? 'error' : ''}
          />
          {errors.name && <span className="error-text">{errors.name}</span>}
        </div>

        <div className="form-group">
          <label>Slug</label>
          <input
            name="slug"
            value={formData.slug}
            onChange={handleSlugChange}
            className={errors.slug ? 'error' : ''}
          />
          {errors.slug && <span className="error-text">{errors.slug}</span>}
        </div>

        <div className="form-group">
          <label>توضیحات (اختیاری)</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary">
            ذخیره
          </button>
          <button 
            type="button" 
            className="btn-secondary"
            onClick={() => navigate('/admin/blog/categories')}
          >
            انصراف
          </button>
        </div>
      </form>
    </div>
  );
}